import type {MetadataItem} from 'src/api/saleor/generated'
import type {VariantObject} from '../interfaces'
import {toVariantObject} from './toVariantObject'

export const getMediaDataVariantObjects = (
  metadata: Partial<MetadataItem>,
): Record<string, VariantObject> | null => {
  try {
    const json = metadata.value
    const value = json ? JSON.parse(json) : {}
    return Object.keys(value).reduce(
      (obj, item) =>
        ({
          ...obj,
          [item]: toVariantObject(value[item]),
        } as Record<string, VariantObject>),
      {} as Record<string, VariantObject>,
    )
  } catch (_e) {
    return null
  }
}
